import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function TimelineRender({ node }) {
  const content = node.content || {};
  
  // Da Arrays komplex für den simplen Inspector sind, 
  // nutzen wir String-Parsing: "Jahr: Titel - Beschreibung | Jahr: Titel - Beschreibung"
  const rawData = content.events || '2024: 5G Start - Flächendeckender Ausbau in Kernstädten | 2025: Gigabit Core - Umrüstung auf Standalone 5G | 2026: 6G Research - Erste Testfelder für Industrie';
  
  const events = rawData.split('|').map(item => {
    const [yearAndTitle, desc] = item.split('-');
    if (!yearAndTitle) return null;
    const [year, title] = yearAndTitle.split(':');
    return {
      year: year ? year.trim() : '',
      title: title ? title.trim() : '',
      desc: desc ? desc.trim() : ''
    };
  }).filter(Boolean);

  const lineColor = content.lineColor || 'rgba(255,255,255,0.1)';
  const dotColor = content.dotColor || 'var(--tef-primary, #00A9E0)';

  return (
    <div style={{
      width: '100%',
      position: 'relative',
      paddingLeft: '30px'
    }}>
      {/* Vertikale Linie */}
      <div style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '11px', // (30px / 2) - 4px (halbe stärke) + paar pixel tweak
        width: '2px',
        backgroundColor: lineColor
      }} />

      {events.map((evt, idx) => (
        <div key={idx} style={{
          position: 'relative',
          marginBottom: idx !== events.length - 1 ? '32px' : '0'
        }}>
          {/* Punkt */}
          <div style={{
            position: 'absolute',
            left: '-24px', // Zurück in die Linie
            top: '4px',
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: dotColor,
            border: '2px solid #0f172a' // Hintergrundfarbe simuliert Lücke
          }} />
          
          {/* Inhalt */}
          <div>
            <span style={{ fontSize: '14px', fontWeight: 'bold', color: dotColor }}>{evt.year}</span>
            <h4 style={{ margin: '4px 0 8px 0', fontSize: '18px', color: '#f8fafc' }}>{evt.title}</h4>
            {evt.desc && <p style={{ margin: 0, fontSize: '14px', color: '#cbd5e1', lineHeight: '1.5' }}>{evt.desc}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}

registry.register('Timeline', {
  label: 'Zeitleiste (Roadmap)',
  icon: '⏳', 
  category: 'advanced',
  component: TimelineRender,
  
  defaultProps: {
    content: {
      events: '2024: 5G Start - Start des Ausbaus | 2025: O2 Grow - Tarifinnovation | 2026: Gigabit - Flächendeckend',
      lineColor: 'rgba(255,255,255,0.1)',
      dotColor: '#00A9E0'
    },
    style: {
      desktop: {
        marginBottom: '20px',
        padding: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Ereignisse',
          fields: [
            { 
              name: 'content.events', 
              label: 'Daten (Jahr: Titel - Text | nächster...)', 
              type: 'textarea' 
            }
          ]
        },
        {
          title: 'Design',
          fields: [
            { name: 'content.lineColor', label: 'Linienfarbe', type: 'color' },
            { name: 'content.dotColor', label: 'Punktfarbe', type: 'color' }
          ]
        }
      ]
    }
  ]
});
